import React, { useState } from "react";
import ReactImageGallery from "react-image-gallery";
import ReactImageMagnify from "@blacklab/react-image-magnify";
import "react-image-gallery/styles/css/image-gallery.css";
import { CDN_BASE_URL } from "../config";

const ProductGallery = ({ images, discount }) => {
  function myRenderItem(propsImage) {
    return (
      <ReactImageMagnify
        imageProps={{
          alt: "Wristwatch by Ted Baker London",
          src: propsImage,
          className: "magniprop",
        }}
        magnifyContainerProps={{
          width: 400,
          height: 400,
          className: "magni",
        }}
        magnifiedImageProps={{
          src: propsImage,
          width: 1200,
          height: 1200,
          className: "magniimg",
        }}
        portalProps={{
          horizontalOffset: 10,
          verticalOffset: 10,
          placement: "over",
        }}
      />
    );
  }
  const ImageGallery = [];
  images?.map((item) =>
    ImageGallery.push({
      original: CDN_BASE_URL + item,
      thumbnail: CDN_BASE_URL + item,
      renderItem: () => myRenderItem(CDN_BASE_URL + item),
    })
  );
console.log(discount)
  return (
    <div className=" relative ">
      {discount && (
        <span className="absolute  top-4 px-4 pt-1 rounded-l-xl h-fit z-10 right-0 bg-red-500 text-white">
          {discount}%
        </span>
      )}
      {ImageGallery.length > 1 ? (
        <ReactImageGallery items={ImageGallery} showNav={false} />
      ) : (<img src={CDN_BASE_URL + images } />)}
    </div>
  );
};

export default ProductGallery;
